export default __webpack_public_path__ + "static/media/ledSpecLogo.66effeea.png";